import { render, staticRenderFns } from "./clientSummary.vue?vue&type=template&id=ec25ac62&scoped=true&"
import script from "./clientSummary.vue?vue&type=script&lang=js&"
export * from "./clientSummary.vue?vue&type=script&lang=js&"
import style0 from "./clientSummary.vue?vue&type=style&index=0&id=ec25ac62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec25ac62",
  null
  
)

export default component.exports